import { useHistory } from "react-router-dom";
import editProfilePopUp from "../../../../../utils/editProfilePopUp";
import ArrowBackIosRoundedIcon from "@mui/icons-material/ArrowBackIosRounded";
import ArrowForwardIosRoundedIcon from "@mui/icons-material/ArrowForwardIosRounded";
const ScreenSwitch = (props) => {
  let history = useHistory();
  const onPrevNextClick = (e, isnext) => {
    e.preventDefault();
    if (!props.isSaved) {
      editProfilePopUp(
        "Warning",
        "Changes you made may not be saved.",
        "warning"
      ).then((data) => {
        if (!data && !isnext) {
          history.push(props.prevLink);
        }
        if (!data && isnext) {
          history.push(props.nextLink);
        }
      });
    } else {
      if (!isnext) {
        history.push(props.prevLink);
      }
      if (isnext) {
        history.push(props.nextLink);
      }
    }
  };
  return (
    <>
      {props.prevLink ? (
        <button
          onClick={(e) => onPrevNextClick(e, false)}
        >
          <ArrowBackIosRoundedIcon fontSize="small" />
          Previous
        </button>
      ) : (
        ""
      )}{" "}
      {props.nextLink ? (
        <button
          onClick={(e) => onPrevNextClick(e, true)}
        >
          Next <ArrowForwardIosRoundedIcon fontSize="small" />
        </button>
      ) : (
        ""
      )}
    </>
  );
};

export default ScreenSwitch;
